// ============================================================================
// ARABIC TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "الوحدة التي تنتج السلام",
    author: "بقلم Emmanuel",
    subtitle: "لكل دين أسبابه، حدودنا تأتي من الماضي",
    description: "وحدة التفكير في الوحدة الروحية والسلام بين التقاليد",
    
    nav: {
      intro: "مقدمة",
      religions: "الأديان",
      common: "الأسس المشتركة",
      humility: "التواضع"
    },

    intro: {
      emmanuelSays: "Emmanuel يقول:",
      ourBordersFromPast: "حدودنا تأتي من الماضي",
      bordersDescription: "لكل دين أسبابه. انقساماتنا ليست إرادة إلهية، بل ثمرة التاريخ والجغرافيا والثقافة.",
      divisionWork: "الانقسام، العزلة من خلال الحواجز وحدود الخوف، هو عمل ماضينا الخطير.",
      sharedHumanity: "ولدنا في تقاليد مختلفة، لكننا نتشارك نفس الإنسانية.",
      
      revelationTitle: "وحي يفتح العيون",
      surprisedLearning: "فوجئت ذات يوم عندما علمت أن اليهود هم أيضاً أبناء الله.",
      angelMichael: "أن الملاك ميخائيل رسول عظيم للمسلمين.",
      jesusNames: "أن يسوع، عيسى، يشوع معروفون بطرق مختلفة، حتى في الإيمان المسيحي.",
      diverseTribes: "لأن هناك قبائل مختلفة، كنائس مختلفة، عائلات مختلفة.",
      sameRealities: "نتحدث عن نفس الحقائق بأسماء مختلفة. هذا يجب أن يقربنا، لا يفرقنا.",
      
      respectTitle: "الاحترام: أساس التواضع، حارس السلام",
      respectFoundation: "حتى لو لم تكن الأخوة قابلة للتطبيق موضوعياً، فإن الاحترام هو أساس التواضع، حارس السلام.",
      understandingProcess: "فهم واحترام الأديان الأخرى هو عملية تواضع. هذا لا يعني التخلي عن إيمانك، بل قبول أن الآخر يبحث عن الحقيقة أيضاً.",
      
      whatBindsUs: "ما يربطنا حقاً",
      seekingRelation: "كل دين يبحث عن العلاقة. كل إنسان يبحث عن السلام.",
      loveOfGod: "هذه العلاقة التي تربطنا جميعاً هي محبة الله.",
      universalLink: "الحب هو الرابط العالمي الذي يتجاوز كل الحدود، كل اللغات، كل التقاليد.",
      
      inclusionTitle: "الشمول: أوسع حتى من التنوع الديني",
      vastInclusion: "التنوع الديني واسع، لكن الأوسع هو شمول الآخرين حيث يدعوهم الله.",
      respectDifferences: "احترام الاختلافات في اللون والجنس، الشمول يجعلنا بشراً فريدين، محبوبين من الله.",
      jesusCommand: "قال يسوع: 'أحبوا بعضكم بعضاً.'",
      
      communitySpirit: "القطع مع الروح الطائفية",
      communityTerror: "الطائفية هي إرهاب كراهية الشر المتنكر. تحول الإيمان إلى هوية قبلية، إلى جدار يفصل، إلى سلاح يجرح.",
      pridePolitics: "أرواحنا الحزبية تدفعنا إلى سياسة الكبرياء:",
      prideQuotes: "أنا محق في إيذائك. أنا محق ونقطة. أنا محق في شن حرب عادلة.",
      watchHeart: "انتبهوا إلى قلب المشكلة، إلى جذر شرنا.",
      refuseDivision: "لنرفض هذا الانحراف الذي يقسم الإنسانية باسم الله.",
      
      freedomTitle: "لتكون حراً، حرر الآخرين",
      freedomOthers: "لتكون حراً، يجب أن تعرف كيف تحرر الآخرين أيضاً.",
      defendFreedom: "حريتي في الإيمان لها قيمة فقط إذا دافعت عن حرية الجميع. قمع الآخر يعني إدانة نفسي بالعبودية.",
      
      changeHeartTitle: "غير قلبك: كن فانوساً حقيقياً",
      recognizeDecency: "الاعتراف بأن اللياقة ليست نفسها للجميع.",
      changeYourself: "التغيير من نفسك أولاً، تدريجياً. غير قلبك، حول حياتك، كن فانوساً حقيقياً.",
      beExample: "لن تتبول على العشب، لأنه سيموت... لا تفرض قواعدك على الآخرين، بل كن مثالاً حياً من خلال تحولك.",
      
      childrenPeaceTitle: "أطفالنا سيعيشون بسلام في التنوع",
      avoidPursuit: "تجنب مطاردة الكلمات بالكلمات.",
      peaceChoice: "إذا اخترنا الاحترام اليوم، فإن أطفال المستقبل سيعيشون بسلام في التنوع. السلام يبدأ بنا، الآن، في كلماتنا وأفعالنا.",
      
      discernTitle: "التمييز: الإنسان أم الله؟",
      manSpeaks: "في كثير من الأحيان، قلب الإنسان هو الذي يتكلم ويقسم.",
      seeFruits: "نراها من ثمار الكلمات: السرقة، الدمار، الحروب. احذروا من التلاعب بالكلمات للتنافس على كبريائكم.",
      
      lookPeaceTitle: "النظر إلى السلام والمحبة",
      lookPeaceAll: "انظر إلى السلام للجميع، انظر إلى محبة الله للآخرين.",
      godSpeaks: "عندما تنتج الكلمات السلام، المصالحة، الوحدة: الله يتكلم. عندما تنتج الانقسام، الكراهية، الحرب: كبرياء الإنسان.",
      
      watchWordsTitle: "راقب كلماتنا",
      watchShares: "راقب مشاركاتنا، راقب كلماتنا المعاكسة الضارة للآخرين.",
      disqualify: "هذه الشرور تستبعدنا نحن أنفسنا. ثمار كلماتنا تكشف من يتكلم فينا: الله أم كبرياؤنا؟",
      
      wisdomMaturityTitle: "الحكمة والنضج في مواجهة طبيعتنا",
      useScriptures: "استخدام الكتب المقدسة (القوانين) لإلحاق الأذى هو عادتنا، عملية طبيعية وماكرة تقريباً.",
      hateSin: "في مواجهة طبيعتنا الخاطئة، نكره الشر والأشخاص الذين يفعلون الشر.",
      separateActs: "لكن بالحكمة والنضج، يجب فصل الأعمال عن فقرنا البشري.",
      compassionNature: "الاعتراف بطبيعتنا الحيوانية التي تحتاج إلى الرحمة والنعمة، مع حماية أنفسنا حسب السياقات.",
      
      denounceLeadersTitle: "شجب القادة الروحيين الفاسدين",
      watchLeaders: "احذروا القادة الروحيين أو المسؤولين الذين يسعون للحفاظ على انحدارهم وخيانتهم سراً.",
      noJustice: "بدون عدالة، لا مثال. بدون معرفة، ضحايا آخرون يهلكون بسبب صمتنا.",
      silenceComplicity: "الصمت أمام الظلم هو تواطؤ. يجب قول الحقيقة لحماية الآخرين."
    },

    religions: {
      title: "أديان متنوعة، إنسانية واحدة",
      intro: "المسيحيون، المسلمون، اليهود، الهندوس، البوذيون... والكثير غيرهم: الجميع يبحث عن الحقيقة",
      theirGod: "إلههم:",
      theGood: "الخير:",
      theEvil: "الشر:",
      theAngels: "الملائكة:",
      theUnity: "الوحدة:",
      values: "القيم:",
    commonGoal: "الهدف المشترك",
    seekingPeace: "تشترك جميع الأديان في هدف مشترك: البحث عن السلام، وتعزيز المحبة، وبناء عالم أفضل. بعيداً عن اختلافاتنا، نحن جميعاً متحدون في هذا السعي للحكمة والانسجام.",
      
      christianity: {
        name: "المسيحية",
        godText: "إله واحد، الأب الخالق",
        goodText: "محبة القريب، المغفرة، السلام",
        evilText: "الكراهية، الأنانية، العنف",
        angelsText: "رسل الله (جبريل، ميخائيل...)",
        unityText: "إله واحد لجميع البشر",
        values: "المحبة,المغفرة,السلام,التواضع,العدالة"
      },
      islam: {
        name: "الإسلام",
        godText: "الله، الواحد الرحيم",
        goodText: "العدالة، الصدقة، السلام",
        evilText: "الظلم، الكذب، الانقسام",
        angelsText: "ملائكة النور (جبريل، ميكائيل...)",
        unityText: "لا إله إلا الله",
        values: "السلام,العدالة,الصدقة,الاحترام,الرحمة"
      },
      judaism: {
        name: "اليهودية",
        godText: "يهوه، الأبدي الواحد",
        goodText: "العدالة، الرحمة، الحياة",
        evilText: "الظلم، النميمة، الكراهية",
        angelsText: "الرسل السماويون (ملاخيم)",
        unityText: "اسمع يا إسرائيل، الرب واحد",
        values: "العدالة,الحياة,الذاكرة,السلام,الدراسة"
      },
      hinduism: {
        name: "الهندوسية",
        godText: "براهمان، الحقيقة العليا",
        goodText: "اللاعنف (أهيمسا)، الواجب الصالح",
        evilText: "العنف، الجهل الروحي",
        angelsText: "الديفا، كائنات سماوية خيرة",
        unityText: "كل شيء واحد في براهمان",
        values: "اللاعنف,الحقيقة,الرحمة,النقاء,الانسجام"
      },
      buddhism: {
        name: "البوذية",
        godText: "لا إله خالق، لكن احترام للمقدس",
        goodText: "الرحمة، الحكمة، السلام",
        evilText: "المعاناة الناجمة عن الجهل",
        angelsText: "البوديساتفا، كائنات مستنيرة",
        unityText: "طبيعة بوذا في كل فرد",
        values: "الرحمة,الحكمة,السلام,اللاعنف,اليقظة"
      }
    },

    common: {
      title: "الأسس المشتركة",
      intro: "الخير، الشر، الملائكة، إله واحد، العلاقة، الشمول: ما يوحد الإنسانية",
      
      goodTitle: "الخير",
      goodDescription: "جميع الأديان تعلم المحبة والعدالة والرحمة",
      goodExamples: "أحب قريبك كنفسك|افعل الخير دون تمييز|احم الضعفاء والمظلومين|قل الحقيقة بلطف|شارك ما لديك",
      
      evilTitle: "الشر",
      evilDescription: "الجميع يدين العنف والكذب والظلم",
      evilExamples: "القتل بدون عدالة|السرقة والاستغلال|الكذب والتشهير|الازدراء والإذلال|الانقسام والكراهية",
      
      angelsTitle: "الملائكة والكائنات الروحية",
      angelsDescription: "تقريباً الجميع يعترف برسل سماويين خيرين",
      angelsExamples: "ملائكة رسل الله|المرشدون الروحيون|كائنات النور|الحماة السماويون|البوديساتفا والديفا",
      
      godTitle: "إله واحد (أو الحقيقة العليا)",
      godDescription: "الأغلبية تؤمن بمصدر واحد، خالق أو حقيقة نهائية",
      godExamples: "المسيحية، الإسلام، اليهودية: إله واحد|الهندوسية: براهمان، الواحد الأعلى|البوذية: طبيعة بوذا الشاملة|الجميع يبحث عن الحقيقة النهائية|الجميع يتوق للوحدة والسلام",
      
      relationTitle: "العلاقة والسلام",
      relationDescription: "ما يوحد حقاً جميع الأديان وجميع البشر",
      relationExamples: "كل دين يبحث عن العلاقة مع الإلهي|كل إنسان يبحث عن السلام|هذه العلاقة التي تربطنا جميعاً هي محبة الله|الحب هو الرابط العالمي|السلام هو طموحنا المشترك",
      
      inclusionTitle: "الشمول: محبوبون من الله",
      inclusionDescription: "التنوع الديني واسع، لكن الأوسع هو الشمول",
      inclusionExamples: "شمول الآخرين حيث يدعوهم الله|احترام اختلافات اللون|احترام اختلافات الجنس|الشمول يجعلنا بشراً فريدين، محبوبين من الله|قال يسوع: 'أحبوا بعضكم بعضاً'",
      
      finalQuote: "فوجئت ذات يوم عندما علمت أن اليهود هم أيضاً أبناء الله، أن الملاك ميخائيل رسول عظيم للمسلمين، أن يسوع، عيسى، يشوع معروفون بطرق مختلفة حتى في الإيمان المسيحي. لأن هناك قبائل مختلفة، كنائس مختلفة، عائلات مختلفة.",
      finalQuote2: "نتحدث عن نفس الحقائق بأسماء مختلفة.",
      quoteAuthor: "Emmanuel، الوحدة التي تنتج السلام"
    },

    humility: {
      title: "7 خطوات نحو التواضع والسلام",
      intro: "العملية للتغلب على الطائفية وأن تصبح فانوساً حقيقياً",
      
      step: "خطوة",
      action: "العمل:",
      
      step1Title: "الاعتراف: حدودنا تأتي من الماضي",
      step1Description: "الانقسام، العزلة من خلال الحواجز وحدود الخوف، هو عمل ماضينا الخطير. انقساماتنا ليست إرادة الله.",
      step1Action: "قبول أن تقليدي لي فقط، وأنا جزء من التنوع الذي أراده الله",
      
      step2Title: "الاحترام: أساس التواضع، حارس السلام",
      step2Description: "حتى لو لم تكن الأخوة قابلة للتطبيق موضوعياً، فإن الاحترام هو الأساس.",
      step2Action: "احترام جميع المعتقدات، حتى دون فهم كل شيء",
      
      step3Title: "الفهم دون حكم",
      step3Description: "اليوم، فهم الآخرين هو عملية تواضع ضرورية.",
      step3Action: "الاستماع حقاً لما يؤمن به الآخرون، دون حكم",
      
      step4Title: "التغيير من نفسك أولاً: كن فانوساً حقيقياً",
      step4Description: "الاعتراف بأن اللياقة ليست نفسها للجميع. غير قلبك تدريجياً، حول حياتك، أصبح نوراً حقيقياً.",
      step4Action: "عدم فرض قواعدي على الآخرين، بل أن أكون مثالاً حياً من خلال تحولي",
      
      step5Title: "القطع مع الروح الطائفية",
      step5Description: "أرواحنا الحزبية تدفعنا إلى سياسة الكبرياء: 'أنا محق في إيذائك، أنا محق ونقطة.' انتبهوا إلى قلب المشكلة، إلى جذر شرنا.",
      step5Action: "رفض خطابات الانقسام في مجتمعي",
      
      step6Title: "لتكون حراً، حرر الآخرين",
      step6Description: "حريتي تعتمد على تلك التي أمنحها للآخرين.",
      step6Action: "الدفاع عن حرية الضمير للجميع، وليس فقط لي",
      
      step7Title: "تجنب مطاردة الكلمات بالكلمات",
      step7Description: "عدم الرد على الكراهية بالكراهية، على الإهانات بالإهانات.",
      step7Action: "اختيار السلام حتى يعيش أطفالنا بسلام في التنوع",
      
      discernFruits: "التمييز بالثمار",
      humanHeart: "قلب الإنسان الذي يقسم",
      lookGodLove: "النظر إلى محبة الله",
      watchOurWords: "راقب كلماتنا",
      
      prideFruits: "ثمار الكبرياء البشري",
      prideFruitsList: "روح الحزبية: \"أنا على حق، نقطة\"|سياسة الكبرياء: \"أنا على حق في إيذائك\"|استخدام الكتب المقدسة للإيذاء (عملية خبيثة)|كره الأشخاص (وليس الأفعال فقط)|قادة روحيون يخفون انحرافهم وعدم أمانتهم|صمت متواطئ في مواجهة الظلم|انقسام وحروب|كراهية متنكرة في صورة تقوى|سرقة ودمار|تلاعب من أجل الكبرياء|ازدراء وعنف",
      
      godFruits: "ثمار محبة الله",
      godFruitsList: "فصل الأفعال عن الشخص بحكمة|الرحمة لفقرنا البشري|النعمة مع حماية أنفسنا حسب السياقات|فضح الظلم لحماية الآخرين|قول الحقيقة بشجاعة|السلام للجميع|الحب دون تمييز|المصالحة والوحدة|التواضع والاحترام|الحرية للجميع",
      
      finalQuote: "حتى لو لم تكن الأخوة قابلة للتطبيق موضوعياً، فإن الاحترام هو أساس التواضع، حارس السلام. تجنب مطاردة الكلمات بالكلمات، وأطفال المستقبل سيعيشون بسلام في التنوع.",
      author: "Emmanuel"
    },

    footer: {
      quote: "الاحترام هو أساس التواضع، حارس السلام. أطفالنا سيعيشون بسلام في التنوع إذا اخترنا الاحترام اليوم.",
      author: "Emmanuel، الوحدة التي تنتج السلام"
    }
};

export default unityTranslations;
